import { notificationApi } from './notificationApi.js'

export const notificationServe = {
  ...notificationApi
}